import {PackInfoExchageActions} from '../actions/pieActions';

//Описание ADMS каталога
const initialPackInfoExchangeState = {
    members: [],        //Список отображаемых элементов
    tags: [],           //Список тегов
    offset: 0,
    limit: 20,
    conditions: [],      //Массив условий отбора. Используется И
    repository: 1,
    view: "catalog",
    selected: {id: null},
    load: false
}
export const pie = (state = { ...initialPackInfoExchangeState} , action) => {
    switch (action.type) {
        case PackInfoExchageActions.LOAD_LIST_OK: 
            return {
                ...state,
                ...action.members,
                view: "catalog",
                load: true
            };
        case PackInfoExchageActions.LOAD_LIST_STARTED: 
            return {
                ...state,
                members: [],
                view: "catalog",
                load: false
            }
        case PackInfoExchageActions.LOAD_LIST_ERROR: 
            return {
                ...initialPackInfoExchangeState
            };

        case PackInfoExchageActions.LOAD_ITEM_OK: 
            return {
                ...state,
                selected: {...action.selected},
                view: "element",
                load: true
            };

        case PackInfoExchageActions.LOAD_ITEM_STARTED: 
            return {
                ...state,
                load: true
            }
        case PackInfoExchageActions.LOAD_ITEM_ERROR: 
            return {
                ...state,
                view: "catalog",
                load: false
            };
        case PackInfoExchageActions.CHANGE_CONDITIONS: 
            return {
                ...state,
                conditions: action.conditions,                
            };
        default:
            return state;
    }
}
